export class GtmSiteDetails {
  gtmScriptId: string;
  gtmAuth: string;
}
